import {
  CheckOutlined,
  InfoCircleOutlined,
  InfoCircleTwoTone
} from "@ant-design/icons";
import { useLookUpByUsernameV2 } from "@entities/brief/lib/hooks/useLookUpUsernameV2";
import { useSuggestInfluencerByUsername } from "@entities/brief/lib/hooks/useSuggestInfluenceUsername";

import { IModifiedGlobalCreator } from "@shared/lib/types";
import { Button } from "@shared/ui/Button";
import { Space, Tag, Tooltip } from "antd";

import { useCampaignStore } from "@entities/global-discovery/store/useCampaignStore";
import styles from "./styles.module.scss";

interface ICampaignSuggestButtonProps {
  influencer: IModifiedGlobalCreator;
}

export function CampaignSuggestButton({
  influencer,
}: ICampaignSuggestButtonProps) {
  const { campaignId } = useCampaignStore();

  const { lookupData, isFetching } = useLookUpByUsernameV2({
    briefId: campaignId || "",
    platform: influencer.work_platform?.name?.toLowerCase(),
    username: influencer.platform_username,
  });
  const { suggest, isSuggesting } = useSuggestInfluencerByUsername("");

  if (!campaignId || isFetching) return null;

  const isCreatorDeclined =
    lookupData?.briefInfluencer?.isBrandDeclined ||
    lookupData?.briefInfluencer?.isCreatorDeclined ||
    lookupData?.briefInfluencer?.status === "Deleted";

  const isCreatorInBrief =
    lookupData?.isInfluencerAlreadyInBreif && !isCreatorDeclined;

  const isCreatorPurchased =
    lookupData?.briefInfluencer?.status === "Purchased";

  const tooltipTitle = isCreatorPurchased
    ? "Creator is already purchased"
    : isCreatorDeclined
    ? "Creator declined"
    : "Creator is already in campaign";

  if (isCreatorInBrief) {
    return (
      <Space align="center">
        <Tag
          color="success"
          icon={<CheckOutlined />}
          className={styles.tooltipText}
        >
          Added
        </Tag>
        <Tooltip title={tooltipTitle}>
          <InfoCircleOutlined style={{ color: "#AFAFAF" }} />
        </Tooltip>
      </Space>
    );
  }

  return (
    <Space>
      <Button
        size="small"
        style={{ width: "fit-content" }}
        onClick={() => {
          suggest({
            data: {
              briefId: campaignId,
              addBySocialMediaHandle: [
                {
                  link: influencer.url,
                  platform: influencer.work_platform?.name?.toLowerCase(),
                  username: influencer.platform_username,
                  followers:
                    influencer.follower_count ||
                    influencer.subscriber_count ||
                    0,
                  estViews: 0,
                },
              ],
            },
          });
        }}
        loading={isSuggesting}
      >
        Add to Campaign
      </Button>
      {isCreatorDeclined && (
        <Tooltip title={tooltipTitle}>
          <InfoCircleTwoTone twoToneColor={["#FF3B30", "#FFE6E4"]} />
        </Tooltip>
      )}
    </Space>
  );
}
